'use client';
import { useSearchParams } from 'next/navigation';

export const useIsDeeplinkFallback = () => {
  const searchParams = useSearchParams();
  return searchParams.get('referrer') === 'deeplink_fallback';
};
